import Vue from 'vue';

async function privacyPolicyExists (companyInformation: any): Promise<boolean> {
  if (companyInformation.URLGDPR) {
    return true;
  }

  const privacyPolicyLink = 'https://www.click2date.eu/OTeV/userdata/images/' +
    companyInformation.CompanyID + '/' + companyInformation.CompanyID + '-privacypolicy.pdf';

  try {
    const downloadResult = await Vue.axios.get(privacyPolicyLink);
    return downloadResult.status === 200 && downloadResult.headers['content-type'] === 'application/pdf';
  } catch (e: any) {
    return false;
  }
};

export default { privacyPolicyExists };
